import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=3ee76f77&scoped=true&"
import script from "./Attachments.vue?vue&type=script&lang=js&"
export * from "./Attachments.vue?vue&type=script&lang=js&"
import style0 from "./Attachments.vue?vue&type=style&index=0&id=3ee76f77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee76f77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ee76f77')) {
      api.createRecord('3ee76f77', component.options)
    } else {
      api.reload('3ee76f77', component.options)
    }
    module.hot.accept("./Attachments.vue?vue&type=template&id=3ee76f77&scoped=true&", function () {
      api.rerender('3ee76f77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/view/Attachments.vue"
export default component.exports